import { useEffect, useState } from 'react'

// メニュー1(フル)→メニュー2(compact)の切替は共通トップと各サービスで同一の動作にする。
// Yuichi 2026-09-17「メニュー1からメニュー2へ切り替わる動作を共通化しろよ。共通トップでやっているアニメーションをすべてに反映しろ。独自実装をするな」
// ヒステリシス: 480px 以上で compact、400px 未満で戻す(境界での震え防止)。
export function useCompactHeader() {
  const [compact, setCompact] = useState(false)
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY
      setCompact((prev) => (prev ? y > 400 : y >= 480))
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
  return compact
}
